import { render } from "./TieredChallengeSellerCard.vue?vue&type=template&id=2f916d26"
import script from "./TieredChallengeSellerCard.vue?vue&type=script&lang=js"
export * from "./TieredChallengeSellerCard.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "./TieredChallengeSellerCard.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Ftmp%2Fbuild_36689b7c%2Fpackages%2Fstore%2Fsrc%2Fcomponents%2Fchallenge%2Ftiered%2FTieredChallengeSellerCard.vue&external"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__